import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  container: {
    marginTop: 10,
    marginBottom: 6,
    // paddingHorizontal: 20,
  },
  subjectLine: {
    fontSize: 10,
    // color: '#374151',
    fontWeight: 'bold',
    marginBottom: 8,
  },
  greeting: {
    fontSize: 9,
    // color: '#374151',
    marginBottom: 6,
  },
  message: {
    fontSize: 9,
    // color: '#374151',
    lineHeight: 1.5,
  },
});

const Subject = ({ invoice }) => {
  const parsedInvoice = JSON.parse(JSON.parse(JSON.stringify(invoice)));

  return (
    <Fragment>
      <View style={styles.container}>
        <Text style={styles.subjectLine}>
          Sub: Booking voucher for reference booking ID: <b>{parsedInvoice.booking_refrence_id}</b>
        </Text>
        <Text style={styles.greeting}>Dear Sir/Madam,</Text>
        <Text style={styles.message}>
          Please find below the details of the prices for the travel items as per your requirements. For booking details, kindly refer below.
        </Text>
      </View>
    </Fragment>
  );
};

export default Subject;
